export function getPublishedRelatedFindings<
  TFinding extends { isPublished?: boolean | null },
>({
  relatedFindings,
}: {
  relatedFindings: TFinding[] | null | undefined;
}): TFinding[] {
  if (!Array.isArray(relatedFindings)) {
    return [];
  }

  return relatedFindings.filter((finding) => !!finding.isPublished);
}

export function countPublishedRelatedFindings({
  relatedFindings,
}: {
  relatedFindings: { isPublished?: boolean | null }[] | null | undefined;
}): number {
  return getPublishedRelatedFindings({ relatedFindings }).length;
}
